import { app } from '../../../../app';

app.component('companyUserDirectoriesSaaspassUsers', {
    templateUrl: require('./saaspass-users.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/saaspass-users.component.js